import { Box } from '@chakra-ui/react'
import { Link } from 'react-router-dom'

export function RoundedNumber({ number, bgColor, ...rest }) {
  return (
    <Box
      as={Link}
      to={rest.to}
      w="70px"
      h="70px"
      borderRadius="100%"
      display="flex"
      alignItems="center"
      justifyContent="center"
      bgColor={bgColor}
      color="white"
      fontWeight="bold"
      fontSize="36px"
      cursor="pointer"
      transition="all 0.2s"
      _hover={{
        filter: 'brightness(.9)',
      }}
      _active={{
        filter: 'brightness(1.1)',
      }}
      {...rest}
    >
      {number}
    </Box>
  )
}
